import { RubyAvatar } from '@/components/shared/RubyAvatar';

export function LemonadeAvatar() {
  return <RubyAvatar size="lg" />;
}
